"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zIndexLevel = exports.zIndex = void 0;
exports.zIndex = {
    popper: 1200,
    dropdown: 1300,
    tooltip: 1400,
};
exports.zIndexLevel = {
    1: { modalBackdrop: 1050, modalContainer: 1100 },
    2: { modalBackdrop: 1250, modalContainer: 1300 },
    3: { modalBackdrop: 1450, modalContainer: 1500 },
    4: { modalBackdrop: 1650, modalContainer: 1700 },
    5: { modalBackdrop: 1850, modalContainer: 1900 },
};
//# sourceMappingURL=zIndex.js.map